<div class="date-range-container">
    <div class="date-range-options" [class.hidden]="hideDateRangeOptions">
        <div class="ui fluid selection dropdown" id="date-range-selector">
            <input
                type="hidden"
                name="timeFrame"
                [ngModel]="dateRangeMode"
                (change)="handleChangeDateRangeMode($event.target.value)"
            />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu">
                <div class="item" data-value="fixed-dates">Custom (Dates)</div>
                <div class="item" data-value="days">Custom (Days)</div>
                <!-- Render list of text options -->
                <div
                    *ngFor="let timeFrame of timeFrames"
                    class="item"
                    [attr.data-value]="timeFrame.value"
                    (click)="handleSelectTimeFrame(timeFrame)"
                >
                    {{ timeFrame.name }}
                </div>
            </div>
        </div>
    </div>

    <ng-container [ngSwitch]="dateRangeMode">
        <ng-container *ngSwitchCase="'fixed-dates'">
            <!-- custom fixed range -->
            <common-date-range-calendar
                [dateStart]="dateStart"
                [dateEnd]="dateEnd"
                (onUpdateFixedDates)="handleUpdateFixedDates($event)"
            ></common-date-range-calendar>
        </ng-container>
        <ng-container *ngSwitchCase="'days'">
            <div class="field field--custom-days">
                Next
                <input
                    type="number"
                    min="1"
                    max="365"
                    [(ngModel)]="customDays"
                    (ngModelChange)="handleUpdateCustomDays(customDays)"
                    class="date-range__days-input"
                />
                Days
                <p *ngIf="customDays < 1 || customDays > 365 || !customDays" class="error">
                    Please enter a number between 1 and 365.
                </p>
            </div>
            <!-- custom days -->
        </ng-container>
        <ng-container *ngSwitchDefault> </ng-container>
    </ng-container>
</div>
